import React, { useEffect, useState } from "react";
import { loadPersistentImage, peekCachedImageSource } from "../services/persistentImageCache";

export default function CachedImage({ src, cacheKey = "", className = "", fallback = null, onLoad, onError, ...props }) {
  const [resolvedSource, setResolvedSource] = useState(() => peekCachedImageSource(src, cacheKey));
  const [status, setStatus] = useState(() => resolvedSource ? "ready" : "loading");

  useEffect(() => {
    let active = true;
    const immediate = peekCachedImageSource(src, cacheKey);
    setResolvedSource(immediate);
    setStatus(immediate ? "ready" : "loading");
    if (!src || immediate) return () => { active = false; };
    loadPersistentImage(src, cacheKey).then((source) => {
      if (!active) return;
      setResolvedSource(source);
      setStatus("ready");
    }).catch(() => {
      if (!active) return;
      setResolvedSource(src);
      setStatus("fallback");
    });
    return () => { active = false; };
  }, [src, cacheKey]);

  return (
    <span className={`cachedImageFrame is-${status}${className ? ` ${className}` : ""}`}>
      {status === "loading" && fallback}
      {resolvedSource && (
        <img
          {...props}
          src={resolvedSource}
          onLoad={onLoad}
          onError={onError}
        />
      )}
      {status === "loading" && <span className="cachedImageShimmer" aria-hidden="true" />}
    </span>
  );
}
